import { Carousel } from "react-responsive-carousel"
import React from "react"

export const CourseCarousel = (props) => (
  <Carousel
    showArrows={false}
    infiniteLoop={props.items.length > 1}
    emulateTouch
    autoPlay
    stopOnHover
    interval={6000}
    showStatus={false}
    showThumbs={props.items.length > 1}
    showIndicators={props.items.length > 1}
  >
    {
      props.items.map(item => {
        return (
          <div key={item}>
            <img
              src={props.data[item.img].childImageSharp.fluid.src}
              alt={props.data[item.img].name} />

            {item.desc ? <p className="legend">
              {item.desc}
            </p> : null}
          </div>
        )
      })
    }
  </Carousel>
)
